import { jwtDecode as decode, type JwtPayload } from 'jwt-decode';

const getTokenExpirationDate = (token: string) => {
  if (!token) return null;

  const decoded = decode(token);
  if (!decoded || !decoded.exp) return null;

  const date = new Date(0);
  date.setUTCSeconds(decoded.exp);

  return date;
};

export const isTokenExpired = (token: string) => {
  const date = getTokenExpirationDate(token);
  const offsetSeconds = 30; //Usefull for simulating short lived tokens(set to 3580 to have 20secs of token "life time").
  if (date === null) {
    return false;
  }

  return !(date.valueOf() > Date.now() + offsetSeconds * 1000);
};

export const isValidCustomerNumberClaim = (token: string) => {
  if (!token) return false;
  const customerNumberClaim = 'http://rikstv.no/claims/customernumber/1';
  const decodedToken = decode<JwtPayload & { [customerNumberClaim]: number }>(token);
  return decodedToken[customerNumberClaim] > 1;
};
